import { gql } from '@apollo/client';

const CREATE_PRODUCT_MUTATION = gql`
  mutation CreateProductMutation(
    $publisherId: ID!,
    $productWorkId: ID,
    $title: String,
    $imprintId: ID,
    $seriesId: ID,
    $description: String,
    $subtitle: String,
    $edition: String,
    $volume: String,
    $formatId: ID!,
    $isbn: String,
    $retailPrice: Float,
    $inventory: Int,
    $cartonQty: Int,
    $shipDate: Date,
    $publicationDate: Date,
    $weight: Float,
    $width: Float,
    $height: Float,
    $thickness: Float,
    $pageCount: Int,
    $adminNotes: String,
    $status: String,
    $creatorIds: String
  ) {
    createProduct(
      publisherId: $publisherId,
      productWorkId: $productWorkId,
      title: $title,
      imprintId: $imprintId,
      seriesId: $seriesId,
      description: $description,
      subtitle: $subtitle,
      edition: $edition,
      volume: $volume,
      formatId: $formatId,
      isbn: $isbn,
      retailPrice: $retailPrice,
      inventory: $inventory,
      cartonQty: $cartonQty,
      shipDate: $shipDate,
      publicationDate: $publicationDate,
      weight: $weight,
      width: $width,
      height: $height,
      thickness: $thickness,
      pageCount: $pageCount,
      adminNotes: $adminNotes,
      status: $status,
      creatorIds: $creatorIds
    ) {
      message
      product {
        id
        # Title comes from productWork now, but let's keep it for potential feedback
        # title # This field is likely removed or moved to productWork
        format { # Assuming format is an object type
          id
          description
        }
        # Include other fields if needed after creation
      }
    }
  }
`;

export default CREATE_PRODUCT_MUTATION;
